import * as types from "../types";

const initialState = {
  data: null,
  loading: false,
  error: null,
  isFreeUser: true
};

const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUBSCRIPTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        isFreeUser: action.payload.name === "Free",
        error: null
      };

    case types.SUBSCRIPTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default subscriptionReducer;